export default __webpack_public_path__ + "static/Element-0f1e5e9eed8cef40d968079a094613ac.mp4";